import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    drawer: localStorage.getItem("sidebard") ? JSON.parse(localStorage.getItem("drawer")) : false
}

const drawerSlice = createSlice({
    name: "drawerSlice",
    initialState,
    reducers: {
        setDrawer: (state, action) => {
            state.drawer = action.payload;
            localStorage.setItem("drawer",JSON.stringify(state));
            return state;
        },
    }
});

export const { setDrawer } = drawerSlice.actions;
export default drawerSlice;